import {Box, BoxProps, SimpleGrid} from '@chakra-ui/react';
import {ProviderTile, ScrollingMenu, ScrollingMenuCard} from 'components/shared';
import React, {FC} from 'react';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse, IProviderItem} from 'types';
import logger from 'utils/logger';

interface Props {
  data?: IProviderItem[];
  withSlider?: boolean;
  isHorizontal?: boolean;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  isDesktop?: boolean;
  boxProps?: BoxProps;
  tileSize?: string;
}

export const ProviderTileList: FC<Props> = React.memo(
  ({myFavorite, onEditFavorite, data, boxProps, isHorizontal = false, tileSize, isDesktop}) => {
    logger.logDebug(':rerender', 'ProviderTileList');

    const providerTile = (item: IProviderItem) => {
      return (
        <ProviderTile
          tileSize={tileSize}
          isMyFavorite={myFavorite.find((items) => items.slug === item.slug)}
          onEditFavorite={onEditFavorite}
          data={item}
          isDesktop={isDesktop}
        />
      );
    };

    if (!data?.length) return null;

    const paddingX = data.length === 10 ? '14px' : '12px';

    if (isHorizontal) {
      return (
        <Box px={['5px', '20px']} overflowY="hidden">
          <ScrollingMenu>
            {data.map((item, index) => (
              <ScrollingMenuCard itemId={`element-${index}`} key={item.id}>
                <Box px={['10px', paddingX]} pt="10px">
                  {providerTile(item)}
                </Box>
              </ScrollingMenuCard>
            ))}
          </ScrollingMenu>
        </Box>
      );
    }

    return (
      <SimpleGrid
        minChildWidth="320px"
        px={[0, '30px']}
        as="ul"
        spacing={['10px', '20px']}
        flexWrap={['nowrap', 'wrap']}
        listStyleType="none"
      >
        {data.map((item, index) => (
          <Box key={index} mx="auto" {...boxProps}>
            {providerTile(item)}
          </Box>
        ))}
      </SimpleGrid>
    );
  },
);
